export const FETCHING = 'FETCHING';
export const SUCCESS = 'SUCCESS';
export const FAILURE = 'FAILURE';
export const ACCESS_STATUS = 'ACCESS_STATUS';
export const ADD_DATA = 'ADD_DATA';